import { ONBOARDING_UTM_SOURCE } from '@/@studio-ai/utils/dani-deep-link';
import { tracking } from '@/lib/features/tracking';

/**
 * Funnel events for the insight-engine email deep links (M4S prospecting &
 * engagement outreach): a link is GENERATED when a rep copies a drafted email
 * carrying a deep-link CTA, and CONSUMED when a recipient lands on /dani via
 * that link. LogRocket props must stay flat scalars.
 */
export type InsightEmailDeepLinkEvent =
    | {
          name: 'insight_engine_email_link_generated';
          props: {
              mode: 'engagement' | 'prospect';
              linkKind: 'engagement-deep-link' | 'prospect-smart-link' | 'prospect-token-link';
              hasInsight: boolean;
          };
      }
    | {
          name: 'insight_engine_email_link_consumed' | 'onboarding_email_link_consumed';
          props: {
              utmSource: string;
              utmCampaign: string;
              utmContent: string;
              promptLength: number;
              autoSubmitted: boolean;
          };
      };

export function trackInsightEmailDeepLink(event: InsightEmailDeepLinkEvent): void {
    tracking.event(event.name, event.props);
}

/**
 * Which funnel a `/dani?prompt=` arrival belongs to.
 *
 * Both programmes land on the same route through the same hook, so without
 * this every trial-onboarding click would be counted as an insight-engine
 * conversion. They answer different questions — one measures whether reps'
 * outreach works, the other whether a trial user reached a first answer — and
 * M4S-5566's success metric (OQ-3) is read off the onboarding one. Splitting at
 * emit keeps the two funnels honest; `utmSource` alone would leave every past
 * and future query needing a filter nobody remembers to apply.
 */
export function emailLinkConsumedEventName(
    utmSource: string,
): 'insight_engine_email_link_consumed' | 'onboarding_email_link_consumed' {
    return utmSource === ONBOARDING_UTM_SOURCE
        ? 'onboarding_email_link_consumed'
        : 'insight_engine_email_link_consumed';
}
